const MaleIcon = ({ viewBox = "0 0 20 20", className = "hayley-h-5 hayley-w-5 hayley-text-secondary" }) => {
  return (
    <svg viewBox={viewBox} fill="none" className={className}>
      <path
        d="M12.1329 4.13333C12.1329 2.95513 11.1778 2 9.99954 2C8.82134 2 7.86621 2.95513 7.86621 4.13333C7.86621 5.31154 8.82134 6.26667 9.99954 6.26667C11.1778 6.26667 12.1329 5.31154 12.1329 4.13333Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11.5999 18.0004H8.39994L7.33327 13.7337H6.2666V10.5337C6.2666 9.96793 6.49136 9.42531 6.89144 9.02523C7.29152 8.62515 7.83414 8.40039 8.39994 8.40039H11.5999C12.1657 8.40039 12.7084 8.62515 13.1084 9.02523C13.5085 9.42531 13.7333 9.96793 13.7333 10.5337V13.7337H12.6666L11.5999 18.0004Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default MaleIcon;
